export default __webpack_public_path__ + "static/media/liquidity-pool-farm.6696438c.png";